import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { restrictLoggedOut, VERIFY_ACCESS } from './actionCreators';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
import { BiData } from '@wix/da-bi/pkg/events';
function* handleRestrictLoggedOut({ payload: { restrictedActionName, returnTo, returnType } }) {
    if (restrictedActionName) {
        const biContext = yield select(getPageBiContext);
        const event = BiData(_object_spread_props(_object_spread({
            evid: 240
        }, biContext), {
            referral_info: restrictedActionName
        }));
        yield call(logBiEvent, event);
    }
    const url = Url.joinLink(undefined, returnTo, returnType);
    ddt.log('yumeruby', 'Loggedout redirect', url);
    window.location.assign(url);
}
function* handleVerifyLoggedOutAccess({ payload: { action, restrictedActionName } }) {
    const isLoggedIn = yield select(getIsLoggedIn);
    if (isLoggedIn) {
        yield put(action);
        return;
    }
    yield call(handleRestrictLoggedOut, restrictLoggedOut({
        restrictedActionName
    }));
}
export default function* loggedOutRootSaga() {
    yield all([
        takeEvery(restrictLoggedOut, handleRestrictLoggedOut),
        takeEvery(VERIFY_ACCESS, handleVerifyLoggedOutAccess)
    ]);
}
